import { render, staticRenderFns } from "./ListDeletedPages.vue?vue&type=template&id=696b2e0c&"
import script from "./ListDeletedPages.vue?vue&type=script&lang=ts&"
export * from "./ListDeletedPages.vue?vue&type=script&lang=ts&"
import style0 from "./ListDeletedPages.vue?vue&type=style&index=0&id=696b2e0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports